import { MenuItem } from '@material-ui/core'
import { StyleSelectorFormsy } from 'app/main/notification/components/StyleSelectFormsy'
import CountryRegionData from 'country-region-data'
import * as R from 'ramda'
import React from 'react'

export function CountrySelectorFormsy(props) {
  const countryOptions = CountryRegionData.map(
    R.pick(['countryName', 'countryShortCode']),
  )
  return (
    <StyleSelectorFormsy {...props}>
      {countryOptions.map((option) => (
        <MenuItem key={option.countryShortCode} value={option.countryShortCode}>
          {option.countryName}
        </MenuItem>
      ))}
    </StyleSelectorFormsy>
  )
}
